import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import UsersTable from "./UsersTable";
import GameHistory from "./GameHistory";
import Orders from "./Orders";
import Withdrawals from "./Withdrawals";
import DailyStatsPage from "./DailyStatsPage";
import { parseJWT } from "../../utils/jwtUtils";

export default function AdminDashboard() {
  const navigate = useNavigate();

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  const [activePage, setActivePage] = useState("users");
  const [isOpen, setIsOpen] = useState(false);
  // console.log("user info : ", userInfo);
  // 🔒 Admin access check
  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    if (!userInfo) {
      navigate("/", { replace: true });
      return;
    }

    // Adjust according to your backend
    if (userInfo.role !== "admin" && !userInfo.isAdmin) {
      navigate("/", { replace: true });
    }
  }, [userInfo, navigate, userInfo]);

  const renderPage = () => {
    switch (activePage) {
      case "users":
        return <UsersTable />;
      case "history":
        return <GameHistory />;
      case "orders":
        return <Orders />;
      case "withdrawals":
        return <Withdrawals />;
      case "daily":
        return <DailyStatsPage />;
      default:
        return <UsersTable />;
    }
  };
  const handlePlayNow = () => {
    navigate("/betamountpage");
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-b from-black to-blue-900 text-white">
      {/* mobile hamburger */}
      <button
        className="md:hidden fixed top-4 right-4 z-50 bg-blue-700 px-3 py-2 rounded"
        onClick={() => setIsOpen(true)}
      >
        ☰
      </button>

      <Sidebar
        activePage={activePage}
        setActivePage={setActivePage}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onPlayNow={handlePlayNow}
      />

      <div className="flex-1 p-2 overflow-y-auto">{renderPage()}</div>
    </div>
  );
}
